import styled from 'styled-components';

export const VesselOptionContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

export const VesselOptionLabel = styled.span`
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const FutureActiveMarker = styled.span`
    flex: 0 0 auto;
    width: 30px;
    padding-top: 3px;
    color: #00447e;
    font-size: 0.8rem;
    opacity: 0.8;
    text-align: center;
`;
